/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { RootStore } from 'src/core/stores/RootStore';
import { HandlerParams } from 'src/core/types/handler';
import { getEntityService } from 'src/luis/core/services/entities/commonEntityService';
import { entitySwaggerToEntityStore } from 'src/luis/core/services/entities/mappers';
import { instanceOfDeNormalizer } from 'src/luis/projects/entities/utils/entitiesDenormalizer';
import { getEntityHandlerGroupUtils } from 'src/luis/projects/entities/utils/entityHelpers';
import { ModelType } from 'src/luis/types/ModelType';
import { SimpleEntityStore } from 'src/luis/types/stores/entities/SimpleEntityStore';

/**
 * Fetches all entities for a given application and version.
 */
export const loadEntitiesHelper = (rootStore: RootStore) => async (params?: HandlerParams) => {
    const { context } = params;
    const { getAppVersionStore } = getEntityHandlerGroupUtils(rootStore);
    const { appId, versionId, forceRefresh } = context;
    const entityService = getEntityService({ context });

    const { entityStoreHouse } = getAppVersionStore({ appId, versionId });

    if (!forceRefresh && (entityStoreHouse.isLoading || entityStoreHouse.isLoaded)) {
        return;
    }

    entityStoreHouse.setIsLoading(true);

    const { entities, labelsPerEntity } = await entityService.getEntities();

    const entityStores = entities.filter(Boolean).map(entity => entitySwaggerToEntityStore(entity, labelsPerEntity[entity.id]));

    entityStores.forEach(eS => {
        if (eS.typeId === ModelType.Simple) {
            (<SimpleEntityStore>eS).children.forEach(c => instanceOfDeNormalizer(c, entityStores));
        }
    });

    entityStoreHouse.setIsLoading(false);
    entityStoreHouse.setItems(entityStores);
    entityStoreHouse.setIsLoaded(true);
};
